import { axiosPut } from '@/api/AxiosApi';
import { sendRequest, EndpointPayload } from '@/api/AxiosRequest';
import { UpdateAdminWalletRequest } from '@/types/stake-db';

const BALANCE_API_URL = process.env.REACT_APP_BALANCE_API_URL;

// 관리자 지갑 수정
export const updateAdminWallet = async (data: UpdateAdminWalletRequest) => {
  const { walletId, ...bodyWithoutWalletId } = data;
  const payload: EndpointPayload = {
    path: `/assetfi/admin/staking/wallets/${walletId}`,
    body: bodyWithoutWalletId,
    apiUrl: BALANCE_API_URL,
    skipConvert: true,
  };

  return await sendRequest(payload, 'updateAdminWallet', axiosPut);
};
